import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1ffb946a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "choose-speach"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_i18n_t = _resolveComponent("i18n-t");
  var _component_Banner = _resolveComponent("Banner");
  var _component_speach_table = _resolveComponent("speach-table");
  var _component_infinite_loading = _resolveComponent("infinite-loading");
  var _component_el_tab_pane = _resolveComponent("el-tab-pane");
  var _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Banner, {
    type: "warning"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_i18n_t, {
        scope: "global",
        keypath: "copy_speaches.speaches_to_copy.warn_message.value",
        tag: "div"
      }, {
        source_platform: _withCtx(function () {
          return [_createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              var _ctx$sourcePlatform;
              return _ctx.goToPlatform((_ctx$sourcePlatform = _ctx.sourcePlatform) === null || _ctx$sourcePlatform === void 0 ? void 0 : _ctx$sourcePlatform.url);
            }),
            class: "choose-speaches-warn-msg"
          }, _toDisplayString(_ctx.$t('copy_speaches.speaches_to_copy.warn_message.source_platform').toString()), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_tabs, {
    class: "choose-speach-tabs"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_tab_pane, {
        label: "All"
      }, {
        default: _withCtx(function () {
          var _ctx$sourcePlatform2;
          return [_createVNode(_component_speach_table, {
            "table-id": 'availableSpeachesTables',
            "list-speach": _ctx.listSpeach,
            onFilterTitle: _ctx.filterTitle,
            onFilterAuthor: _ctx.filterAuthor,
            onFilterCategory: _ctx.filterCategory,
            searchable: "",
            loading: _ctx.loading,
            "checked-speach-ids": _ctx.listCheckedSpeachSearchList.map(function (speach) {
              return speach.speachID;
            }),
            onCheck: _ctx.check,
            onAllCheck: _ctx.allCheck,
            "platform-id": (_ctx$sourcePlatform2 = _ctx.sourcePlatform) === null || _ctx$sourcePlatform2 === void 0 ? void 0 : _ctx$sourcePlatform2.platformID,
            "header-checkable": true,
            "check-all-message": _ctx.checkAllMessage,
            "uncheck-all-message": _ctx.uncheckAllMessage,
            "total-of-speaches-search": _ctx.totalNumber,
            "search-filters": _ctx.searchFilters,
            onSelectAllFromBack: _ctx.selectAllFromBack,
            onClearAllFromBack: _ctx.clearAllFromBack
          }, null, 8, ["list-speach", "onFilterTitle", "onFilterAuthor", "onFilterCategory", "loading", "checked-speach-ids", "onCheck", "onAllCheck", "platform-id", "check-all-message", "uncheck-all-message", "total-of-speaches-search", "search-filters", "onSelectAllFromBack", "onClearAllFromBack"]), _createVNode(_component_infinite_loading, {
            onInfinite: _ctx.debounceInfinite,
            identifier: _ctx.infiniteLoaderID
          }, {
            "no-more": _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }, 8, ["onInfinite", "identifier"])];
        }),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "Selected"
      }, {
        default: _withCtx(function () {
          var _ctx$listCheckedSpeac;
          return [(_ctx$listCheckedSpeac = _ctx.listCheckedSpeach) !== null && _ctx$listCheckedSpeac !== void 0 && _ctx$listCheckedSpeac.length ? (_openBlock(), _createBlock(_component_speach_table, {
            key: 0,
            "table-id": "'selectedSpeachesTables'",
            "list-speach": _ctx.listCheckedSpeach,
            "checked-speach-ids": _ctx.listCheckedSpeach.map(function (speach) {
              return speach.speachID;
            }),
            onCheck: _ctx.checkFromSelectedList,
            onEmptyCourVisible: _ctx.refreshCourAndAddToListChecked
          }, null, 8, ["list-speach", "checked-speach-ids", "onCheck", "onEmptyCourVisible"])) : _createCommentVNode("", true)];
        }),
        _: 1
      })];
    }),
    _: 1
  })]);
}